
//these funcitons are called by kitchen-sink-service


    //Reactionts_Left is used when uploading JSON files, to check if there are reactors present
    export function reactions_Left(element_Array) {
        let reactions_list = []
        let reactions_Left = false
        for (let i = 0; i < element_Array.length; i++) {
            if (element_Array[i].prop('reaction')) {
                if (element_Array[i].prop('rx_spec') == false) {
                    reactions_Left = true
                    reactions_list.push(element_Array[i])
                    reactions_Left = true
                }
            }
        }
        return [reactions_Left, reactions_list]
    }

    export function spec_Reactions(element_Array) {
        for (let i = 0; i < element_Array.length; i++) {
            let element = element_Array[i]
            // Get components from a single source
            let unit_Components = Object.keys(element.attributes['components'])

            if (!element.attributes['equipment_Properties']['rx_Data']) {
                element.attributes['equipment_Properties']['rx_Data'] = {}
                //this line intilalizes rx_Data array

                for (let j = 0; j < unit_Components.length; j++) {
                    let component = unit_Components[j]
                    element.attributes['equipment_Properties']['rx_Data'][component] = {
                        molmass: element.attributes['components'][component]['M'],
                        stoich: 0
                    } //this line sets the component molmass and stoich to 0
                }
            }
            this.handleOpenWizard(element)
        }
    }

    export function update_SpecReactions(unit_Components, rx_Data, molecularWeights) {

        //check if unit components match the rx_Data components
        //if not, update rx_Data to include new components with stoich 0
        for (const component of unit_Components) {
            if (!rx_Data[component]) {
                rx_Data[component] = {
                    molmass: molecularWeights[component] || '',
                    stoich: 0
                }
            }
        }

    }
